module.exports = __webpack_public_path__ + "static/media/hamburger-menu.552ba5d2.svg";